const FEED = [
  { tag: "圈子", text: "某头部 MCN 被爆抽成比例谈崩，头部主播连夜改合同" },
  { tag: "爆料", text: "某平台 2026 年度盛典入围名单疑提前泄露，名单遭全网对表" },
  { tag: "饭圈", text: "超话主持空降引发撕榜，评论区已开启控评模式" },
  { tag: "幕后", text: "幕后综艺跟拍团集体沉默，片场氛围成谜" },
];

export default function BreakingStrip() {
  return (
    <section className="border-b border-foreground-200/60 bg-background-100">
      <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-3 md:flex-row md:items-center md:gap-6 md:px-6">
        <div className="flex shrink-0 items-center gap-2">
          <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-background-50">
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
            快讯
          </span>
          <span className="hidden text-xs tracking-widest text-primary-700 sm:inline">LIVE</span>
        </div>
        <ul className="flex flex-col gap-1.5 overflow-hidden">
          {FEED.map((item, idx) => (
            <li key={idx} className="flex items-start gap-2 text-sm text-foreground-700 md:flex-row">
              <span className="shrink-0 whitespace-nowrap rounded bg-secondary-200/80 px-1.5 py-0.5 text-xs font-medium text-secondary-800">
                {item.tag}
              </span>
              <span className="leading-relaxed">{item.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}